import React from "react"
import { AccountSummaryButtonView } from "react-ui-components/components/account"

import { useUserStore } from "./components/stores/userStore"
import { auth } from "./firebaseAuth"
import { colors } from "./theme"
import { openProfileOrLoginPopup } from "./utils/lazyPopups"

export const UserQuickInfo: React.FC = () => {
  const { user, isLoggedIn } = useUserStore()
  // const [userInfo] = useAuthState(auth)
  // compute the profile image the same way `UserAvatar` would: prefer store value then auth
  const profileImageUrl = user?.profileImageUrl || auth.currentUser?.photoURL || null
  const displayName = user?.displayName || user?.name || auth.currentUser?.displayName
  const contact = user?.email || user?.phoneNumber || auth.currentUser?.email || auth.currentUser?.phoneNumber

  return (
    <AccountSummaryButtonView
      isLoggedIn={isLoggedIn}
      onClick={() => void openProfileOrLoginPopup(isLoggedIn)}
      avatarSrc={profileImageUrl}
      displayName={displayName}
      contact={contact}
      avatarSize={40}
      secondaryTextColor={colors.textSecondary}
    />
  )
}
